const PageShell = ({ children, containerClassName }) => {
  return <div className={containerClassName || 'container'}>{children}</div>;
};

export default PageShell;
